module.exports = __webpack_public_path__ + "img/37.8.TSS.58ad8c69.png";